export function formatDate(isoString: string): string {
  const date = new Date(isoString);

  // Options for the format: 3 July, 2025
  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  return date.toLocaleDateString("en-GB", options);
}

/**
 * Converts a possibly relative status URL to an absolute one.
 * If the URL is already absolute (starts with http/https), it is returned unchanged.
 */
export function toAbsolute(statusUrl: string, baseUrl?: string): string {
  if (!baseUrl) return statusUrl;
  if (/^https?:\/\//i.test(statusUrl)) return statusUrl;
  return `${baseUrl.replace(/\/$/, '')}/${statusUrl.replace(/^\//, '')}`;
}
